import React from 'react';
import PropTypes from 'prop-types';

class RangeInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      animationInterval: undefined,
      value: props.initialValue,
      sliderValue: props.initialValue
    };
  }

  componentDidMount() {
    this.updateParentComponent();
  }

  handleChange(event) {
    this.updateCurrentValue(event.target.value);
  }

  handleMouseUp() {
    this.updateParentComponent();
  }

  handleLeftArrowClick() {
    const newValue = this.state.value - this.props.step;
    if (newValue >= this.props.min) {
      this.updateCurrentValue(newValue, true);
    }
  }

  handleRightArrowClick() {
    const newValue = this.state.value + this.props.step;
    if (newValue <= this.props.max) {
      this.updateCurrentValue(newValue, true);
    }
  }

  render () {
    return (
      <div className={'range-input ' + this.props.className}>
        { this.props.displayValue &&
          <span className="range-input__value">
            {this.valueAsString()}
          </span>
        }

        <span className="range-input__slider">
          <span
            className="range-input__left-arrow"
            onClick={this.handleLeftArrowClick.bind(this)} />

          <input
            className="range-input__input"
            type="range"
            min={this.props.min}
            max={this.props.max}
            step={this.props.step}
            value={this.state.sliderValue}
            onChange={this.handleChange.bind(this)}
            onMouseUp={this.handleMouseUp.bind(this)}
          />

          <span
            className="range-input__right-arrow"
            onClick={this.handleRightArrowClick.bind(this)} />
        </span>
      </div>
    );
  }

  valueAsString() {
    let value = this.state.sliderValue;
    if (value >= this.props.max) {
      value = `${this.props.max}+`;
    }
    else if (value <= this.props.min) {
      value = `< ${this.props.min}`;
    }
    return value;
  }

  updateCurrentValue(value, forceUpdate=false) {
    value = parseInt(value);

    this.setState({ value }, () => {
      this.setSliderValue(value);

      if (this.props.continousUpdates || forceUpdate) {
        this.updateParentComponent();
      }
    });
  }

  updateParentComponent() {
    if (this.props.onRangeInput) {
      this.props.onRangeInput(this.state.value);
    }
  }

  setSliderValue(value) {
    if (this.props.animateSlider) {
      this.animateChange(this.state.sliderValue, value);
    } else {
      this.setState({ sliderValue: value });
    }
  }

  animateChange(fromValue, toValue) {
    let currValue = fromValue;
    const step = this.props.step;
    const direction = (toValue > fromValue) ? 1 : 0;

    const startAnimation = () => {
      this.setState({animationInterval: setInterval(animate, 1)});
    };

    const endAnimation = () => {
      clearInterval(this.state.animationInterval);
      this.setState({animationInterval: null});
    };

    const animate = () => {
      const shouldEndAnimation = () => {
        return (direction === 1) ? currValue >= toValue : currValue <= toValue;
      };

      const getNextStep = () => {
        return currValue = (direction === 1) ? currValue += step : currValue -= step;
      };

      if (shouldEndAnimation()) {
        endAnimation();
      } else {
        this.setState({ sliderValue: getNextStep() });
      }
    };

    if (this.state.animationInterval) {
      endAnimation();
    }

    startAnimation();
  }
}

RangeInput.defaultProps = {
  className: '',
  animateSlider: true,
  displayValue: true,
  min: 1,
  max: 99,
  step: 1,
  initialValue: 35,
  continousUpdates: false
};

RangeInput.propTypes = {
  questionId: PropTypes.string,
  className: PropTypes.string,
  animateSlider: PropTypes.bool,
  displayValue: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  initialValue: PropTypes.number,
  continousUpdates: PropTypes.bool,
  onRangeInput: PropTypes.func
};

export default RangeInput;
